import { create } from "zustand";
import { UserDto } from "../dto/user.dto";

interface UserStore {
  user: UserDto | null;
  addPoints: (points: number) => void;
  setPoints: (points: number) => void;
  subtractPoints: (points: number) => void;
  updateUser: (userData: UserDto) => void;
  clearUser: () => void;
}

export const useUser = create<UserStore>((set, get) => ({
  user: null,

  addPoints: (points: number) => {
    const currentUser = get().user;
    if (!currentUser) return;

    set({
      user: {
        ...currentUser,
        points: (currentUser.points || 0) + points,
      },
    });
  },

  setPoints: (points: number) => {
    const currentUser = get().user;
    if (!currentUser) return;

    set({
      user: {
        ...currentUser,
        points,
      },
    });
  },

  subtractPoints: (points: number) => {
    const currentUser = get().user;
    if (!currentUser) return;

    set({
      user: {
        ...currentUser,
        points: Math.max(0, (currentUser.points || 0) - points),
      },
    });
  },

  updateUser: (userData: UserDto) => {
    set({ user: userData });
  },

  clearUser: () => {
    set({ user: null });
  },
}));
